/**
 * Keeps the cart drawer out of the first-load JavaScript. The real drawer is
 * fetched the moment the cart is first opened (and stays mounted afterwards,
 * so close animations and state behave exactly as before).
 */
import { lazy, Suspense, useEffect, useState } from "react";

const CartDrawer = lazy(() =>
  import("@/components/CartDrawer").then((m) => ({ default: m.CartDrawer })),
);

export function LazyCartDrawer({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (open) setMounted(true);
  }, [open]);

  if (!mounted) return null;
  return (
    <Suspense fallback={null}>
      <CartDrawer open={open} onOpenChange={onOpenChange} />
    </Suspense>
  );
}
